// Helpers shared across probes. Kept tiny and self-contained so they can be
// inlined into the embedded SDK build without dragging the world.

export function djb2Hash(str: string): string {
  let hash = 5381;
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) & 0xffffffff;
  }
  return (hash >>> 0).toString(16);
}

export interface ShaderPrecision {
  rangeMin: number;
  rangeMax: number;
  precision: number;
}

export function fmtPrec(p: WebGLShaderPrecisionFormat | null): ShaderPrecision | null {
  if (!p) return null;
  return { rangeMin: p.rangeMin, rangeMax: p.rangeMax, precision: p.precision };
}

// Some WebKit versions refuse to create a WebGL context on detached canvases
// or silently throttle them on backgrounded tabs. Attach offscreen, then
// detach in finally.
export function attachedCanvas(w: number, h: number): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = w || 1;
  c.height = h || 1;
  c.style.position = 'absolute';
  c.style.left = '-9999px';
  c.style.top = '-9999px';
  c.style.width = `${w || 1}px`;
  c.style.height = `${h || 1}px`;
  c.style.opacity = '0';
  c.style.pointerEvents = 'none';
  if (document.body) {
    try { document.body.appendChild(c); } catch { /* proceed detached */ }
  }
  return c;
}

export function detachCanvas(c: HTMLCanvasElement | null): void {
  if (c && c.parentNode) {
    try { c.parentNode.removeChild(c); } catch { /* ok */ }
  }
}
